module.exports = __webpack_public_path__ + "static/survival-zwemmen-snorkeltje-a2d7d6fe62d56fe15ca3142344232085.svg";